import { merge } from 'lodash';
import type { FormSchemaType } from './schema';

/**
 * @param data - The initial data give /init
 */
export default (data: FormSchemaType): FormSchemaType => {
    return merge(
        {
            DemandeTarif: {
                FamilleProduit: 'Delivery',
                Police: {
                    FractionnementChoisi: 'M',
                },
                ListePersonnes: [
                    {
                        Civilite: '3',
                        Souscripteur: true,
                        TypePersonne: 'M',
                        RoleConducteur: 'N',
                    },
                ],
            },
            DemandeContrat: {
                ModePaiementTerme: 'P', // P --> Prélèvement, B --> Chèque
                Signature: true,
                SignatureMethod: 'sms',
            },
            // comme on reécrase avec les valeurs de /fill, /save_devis, ... on peut mettre des valeurs qui ne sont pas save
            // url_return: window.location.origin.toString(),
            // redirection: false,
        } as FormSchemaType,
        data,
    );
};
